import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';
import type { Game } from 'chessboard/model/game/types';

/**
 * Create the getPosition method.
 */
export function createGetPosition(context: API.Context) {
  /**
   * Get a position with the move id and line id. If omitted, will return the current position.
   */
  return function getPosition(
    moveId?: number,
    lineId?: number,
  ): Game.Move.Node | JCE.Position.Starting {
    const { game } = context;

    return game._getPos(moveId, lineId); // eslint-disable-line no-underscore-dangle
  };
}
